//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

// OAS-12992: hard-disable the *legacy* customer "Data Science" tab
// (ArangoGraphML ML Services + Notebooks under #dataScience).
//
// This is NOT the ArangoDB Platform "Data Science Platform" bundle
// (`arangodb_platform_bundle` / `datascience` / ArangoPlatform*). Do not
// gate platform bundle selectors, /ui/, or platform ITs with this flag.
export const isDataScienceUIEnabled = false;
